import { usePermission } from "@/shared/permission";

/** Permission codes the warehouse screens depend on; the codes are shown in "permission required" tooltips. */
const CODES = {
  add: "PRT_WRH_ADD",
  edit: "PRT_WRH_EDIT",
  list: "PRT_WRH_LIST",
  detail: "PRT_WRH_DETAIL",
} as const;

export function useWarehousePermissions() {
  return {
    add: usePermission(CODES.add),
    edit: usePermission(CODES.edit),
    list: usePermission(CODES.list),
    detail: usePermission(CODES.detail),
    codes: CODES,
  };
}

export type WarehousePermissions = ReturnType<typeof useWarehousePermissions>;
